// Imports

import React, { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react';

import BaseLayout from './BaseLayout';
import LandingLayout from './LandingLayout';
import { LayoutEnum } from '../../enums';
import { useLayout } from '../../hooks';

// Conponent
const Layout: FunctionComponent<PropsWithChildren> = ({ children }): JSX.Element => {
  const [{ ActiveLayout }, setState] = useState<any>({
    ActiveLayout: BaseLayout,
  });

  const { layout } = useLayout();

  useEffect((): void => {
    switch (layout) {
      case LayoutEnum.BASE_LAYOUT:
        setState({ ActiveLayout: BaseLayout });
        break;
      case LayoutEnum.LANDING_PAGE_LAYOUT:
        setState({ ActiveLayout: LandingLayout });
        break;
      default:
        setState({ ActiveLayout: BaseLayout });
        break;
    }
  }, [layout]);

  return <ActiveLayout>{children}</ActiveLayout>;
};

// Export
export default Layout;
